/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactSynopsisElement } from './ContactSynopsisElement';
import {
    ContactSynopsisElementFromJSON,
    ContactSynopsisElementFromJSONTyped,
    ContactSynopsisElementToJSON,
} from './ContactSynopsisElement';
import type { SynopsisEvaluationRating } from './SynopsisEvaluationRating';
import {
    SynopsisEvaluationRatingFromJSON,
    SynopsisEvaluationRatingFromJSONTyped,
    SynopsisEvaluationRatingToJSON,
} from './SynopsisEvaluationRating';

/**
 * A human evaluation of a contact summary
 * @export
 * @interface SynopsisEvaluationDetails
 */
export interface SynopsisEvaluationDetails {
    /**
     * A user-editable synopsis
     * @type {Array<ContactSynopsisElement>}
     * @memberof SynopsisEvaluationDetails
     */
    synopsis?: Array<ContactSynopsisElement>;
    /**
     * 
     * @type {SynopsisEvaluationRating}
     * @memberof SynopsisEvaluationDetails
     */
    rating?: SynopsisEvaluationRating;
}


/**
 * Check if a given object implements the SynopsisEvaluationDetails interface.
 */
export function instanceOfSynopsisEvaluationDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SynopsisEvaluationDetailsFromJSON(json: any): SynopsisEvaluationDetails {
    return SynopsisEvaluationDetailsFromJSONTyped(json, false);
}

export function SynopsisEvaluationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SynopsisEvaluationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'synopsis': !exists(json, 'synopsis') ? undefined : ((json['synopsis'] as Array<any>).map(ContactSynopsisElementFromJSON)),
        'rating': !exists(json, 'rating') ? undefined : SynopsisEvaluationRatingFromJSON(json['rating']),
    };
}

export function SynopsisEvaluationDetailsToJSON(value?: SynopsisEvaluationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'synopsis': value.synopsis === undefined ? undefined : ((value.synopsis as Array<any>).map(ContactSynopsisElementToJSON)),
        'rating': SynopsisEvaluationRatingToJSON(value.rating),
    };
}

